import Header from 'components/Header/Header';
import './style.css'
import PageHeader from 'components/PageHeader/PageHeader';
import { useLanguageContext } from 'context/LanguageProvider';
import SEO from 'pages/SEO';
import React, { useEffect } from 'react';
import { siteConfiguration } from 'siteConfig';

const Programme = () => {
	const { Programme } = siteConfiguration;
	const { currentLanguage } = useLanguageContext();

	useEffect(() => {
    if (window.__pretalx_loaded__ || customElements.get("pretalx-schedule")) {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://pretalx.com/state-of-the-map-africa-2025/widgets/schedule.js";
    script.async = true;
    document.body.appendChild(script);

    window.__pretalx_loaded__ = true;
  }, []);

	return (
		<>
			
			<SEO title={'Programme'} url={'/programme'} />
			<Header />
			{/* <PretalxLoader /> */}
			<div className="aboutpage-section programme">
				<PageHeader
					title={Programme.title[currentLanguage]}
					picture={Programme.picture}
				/>

			
				<pretalx-schedule event-url="https://pretalx.com/state-of-the-map-africa-2025/" locale={currentLanguage}></pretalx-schedule>
				
				<noscript>
					<div class="pretalx-widget">
						<div class="pretalx-widget-info-message">
							JavaScript is disabled in your browser. To access our schedule without JavaScript,
							please <a target="_blank" href="https://pretalx.com/state-of-the-map-africa-2025/" rel="noreferrer">click here</a>.
						</div>
					</div>
				</noscript>
			</div>
		</>
	);
};

export default Programme;
